export enum ErrorMessage {
  EMAIL_DOMAIN_NOT_SUPPORTED = 'Email domain not allowed.',
}

export enum OtpError {
  LOGIN_FAILURE = 'Login failure',
  SESSION_TIMEOUT = 'Session has timed out',
  RESEND_OTP_LIMIT_EXCEED = 'Resend OTP Limit exceeded',
  MS_TIMEOUT = 'Timeout while calling MS',
  INVALID_AUTHID = 'Authentication Error: Invalid AuthId',
  INCORRECT_OTP = 'incorrectOtpAlertMessage',
}

export const OtpErrorMessage: Record<OtpError, string> = {
  [OtpError.LOGIN_FAILURE]: $localize`You have entered an incorrect OTP and reached the maximum number of attempts. Please try again.`,
  [OtpError.SESSION_TIMEOUT]: $localize`Your session has expired due to inactivity. Please start again.`,
  [OtpError.RESEND_OTP_LIMIT_EXCEED]: $localize`You've reached the maximum number of attempts. Please try again.`,
  [OtpError.MS_TIMEOUT]: $localize`You have entered an incorrect phone number.`,
  [OtpError.INVALID_AUTHID]: $localize`Authentication error. Please try again.`,
  [OtpError.INCORRECT_OTP]: $localize`Please enter the one-time passcode (OTP) sent to your phone number to continue.`,
};
